// services/api/employeeApi.js
import axiosInstance from "utils/axiosInstance";

const employeeDashboardApi = {
  /**
   * Fetches all departments
   * @returns {Promise<Array>} A promise that resolves to an array of department objects
   */
  getDepartments: async () => {
    const response = await axiosInstance.get('/departments/getall');
    return response.data;
  },

  /**
   * Fetches an employee by ID
   * @param {string} employeeId - The ID of the employee to fetch
   * @returns {Promise<Object>} A promise that resolves to the employee object
   */
  getEmployee: async (employeeId) => {
    const response = await axiosInstance.get(`/employee/me/${employeeId}`);
    return response?.data?.data?.employee || {};
  },

  /**
   * Updates an employee's profile
   * @param {string} employeeId - The ID of the employee to update
   * @param {Object} data - The profile data to update
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  updateProfile: async (employeeId, data) => {
    const response = await axiosInstance.post(
      `/employee/update-profile/${employeeId}`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  },

  /**
   * Updates an employee's profile with files
   * @param {string} employeeId - The ID of the employee to update
   * @param {Object} data - The profile data to update
   * @param {Array<File>} files - The files to upload
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  updateProfileWithFiles: async (employeeId, data, files) => {
    const formData = new FormData();
    
    // Attach JSON data as a string field called "data"
    formData.append("data", JSON.stringify(data));

    // Attach all files
    files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await axiosInstance.post(
      `/employee/update-profile/${employeeId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  }
};

export default employeeDashboardApi;